export default "__VITE_ASSET__e7452ef4__"